// @flow

import React from 'react';
import GlobalSearch from 'components/GlobalSearch/GlobalSearch';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'react-aaui/lib/grid/Col';
import Container from 'components/Container/Container';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import type { L10n } from 'type/type';
import './SearchBar.scss';

type Props = {
  onSearch: () => void,
  labelText?: string,
  placeholder?: string,
  size: string,
  keywordsValue: string,
  handleChange: (value: string) => void,
  l10n: L10n
}
export class SearchBar extends React.PureComponent<Props> {
  onSearch = () => {
    this.props.onSearch();
  }

  handleChange = (value: string) => {
    this.props.handleChange(value);
  }

  render() {
    const {
      labelText = 'components.searchBar.label', placeholder, size, keywordsValue, l10n,
    } = this.props;
    return (
      <Container className="search-bar">
        <div className="search-bar__wrapper">
          <Row gutter={0} fluid align="center" className="search-bar__row">
            <Col sm={6} className="search-bar__label">
              {
                <span dangerouslySetInnerHTML={{ __html: l10n.formatMessage(labelText) }} /> // eslint-disable-line
              }
            </Col>
            <Col sm={6} className="search-bar__search">
              <GlobalSearch
                onSearch={this.onSearch}
                placeholder={placeholder}
                size={size}
                keywordsValue={keywordsValue}
                handleChange={this.handleChange} />
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}

export default injectL10n()(SearchBar);
